import type { ConnectedPosition } from '@angular/cdk/overlay';

import type { Observable } from 'rxjs';

import type { OverlayPosition } from '../../editor/types';

export enum FontSize {
  Small = 'small',
  Normal = 'normal',
  Medium = 'medium',
  Large = 'large',
  XLarge = 'x_large',
}

export const FontSizeMap: Record<FontSize, string> = {
  [FontSize.Small]: '0.9',
  [FontSize.Normal]: '',
  [FontSize.Medium]: '1.1',
  [FontSize.Large]: '1.2',
  [FontSize.XLarge]: '1.3',
};

export interface SizeMenuController {
  open: (
    position: OverlayPosition | DOMRect,
    _options: {
      getActiveVal: () => string | null;
      preferredPositions?: ConnectedPosition[];
    },
  ) => { element: HTMLElement; backdropClick$: Observable<MouseEvent> };
  close: () => void;
  updatePosition: (position: OverlayPosition) => void;
  isOpen: () => boolean;
  setSelectCallback: (selectCb: (val: string) => void) => void;
}
